import { getReservationHistory } from 'api/reservationHistoryApi'
import { useState } from 'react'
import {
	Box,
} from '@mui/material'
import { useQuery } from 'react-query'
import dayjs from 'dayjs'
import { DataGrid, GridColDef, GridEventListener, GridToolbarQuickFilter, GridValueGetterParams } from '@mui/x-data-grid'


const columns: GridColDef[] = [
	{ field: 'reservation_id', headerName: 'ID записи', width: 100 },
	{
		field: 'user.first_name', headerName: 'Имя', width: 150,
		valueGetter: (params: GridValueGetterParams) => params.row.user.first_name
	},
	{
		field: 'user.last_name', headerName: 'Фамилия', width: 150,
		valueGetter: (params: GridValueGetterParams) => params.row.user.last_name
	},
	{
		field: 'user.phone_number', headerName: 'Номер телефона', width: 150,
		valueGetter: (params: GridValueGetterParams) => params.row.user.phone_number
	},
	{
		field: 'workplace.name', headerName: 'Рабочее место', width: 150,
		valueGetter: (params: GridValueGetterParams) => params.row.workplace.name
	},
	{
		field: 'created_at', headerName: 'Дата изменения', width: 200,
		type: 'dateTime',
		valueGetter: (params: GridValueGetterParams) => {
			let date = dayjs(params.value)

			return date.isValid() ? date.toDate() : '-'
		}
	},
	{
		field: 'update_initiator.username', headerName: 'Автор изменения', width: 150,
		valueGetter: (params: GridValueGetterParams) => params.row.update_initiator.username
	},
	{
		field: 'action_type.description', headerName: 'Тип изменения', width: 150,
		valueGetter: (params: GridValueGetterParams) => params.row.action_type.description
	},
	{
		field: 'reservation_start', headerName: 'Начало брони', width: 200,
		type: 'dateTime',
		valueGetter: (params: GridValueGetterParams) => {
			let date = dayjs(params.value)

			return date.isValid() ? date.toDate() : '-'
		}
	},
	{
		field: 'reservation_end', headerName: 'Конец брони', width: 200,
		type: 'dateTime',
		valueGetter: (params: GridValueGetterParams) => {
			let date = dayjs(params.value)

			return date.isValid() ? date.toDate() : '-'
		}
	},
	{
		field: 'admin_info.actual_work_start', headerName: 'Начало брони (факт)', width: 200,
		type: 'dateTime',
		valueGetter: (params: GridValueGetterParams) => {
			let date = dayjs(params.row.admin_info.actual_work_start)

			return date.isValid() ? date.toDate() : '-'
		}
	},
	{
		field: 'admin_info.actual_work_end', headerName: 'Конец брони (факт)', width: 200,
		type: 'dateTime',
		valueGetter: (params: GridValueGetterParams) => {
			let date = dayjs(params.row.admin_info.actual_work_end)

			return date.isValid() ? date.toDate() : '-'
		}
	},
]

export const ReservationHistoryList = () => {
	// const [page, setPage] = useState<number>(0)
	// const [rowsPerPage, setRowsPerPage] = useState<number>(10)

	const reservationHistoryDataQuery = useQuery('reservation_history', getReservationHistory)

	// 	const handleChangePage = (event: unknown, newPage: number) => {
	// 		setPage(newPage)
	// 	}

	// 	const handleChangeRowsPerPage = (
	// 		event: React.ChangeEvent<HTMLInputElement>
	// 	) => {
	// 		setRowsPerPage(parseInt(event.target.value, 10))
	// 		setPage(0)
	// 	}

	return (
		<>
			<Box>
				<Box sx={{ height: "100vh" }}>
					<DataGrid
						rows={reservationHistoryDataQuery.data?.body || []}
						columns={columns}
						autoPageSize
						disableSelectionOnClick
						initialState={{
							sorting: {
								sortModel: [
									{ field: 'first_name', sort: 'asc' }
								],
							},
						}}
						components={{ Toolbar: GridToolbarQuickFilter }}
						componentsProps={{
							toolbar: {
								variant: 'outlined',
								placeholder: 'Поиск...',
							},
						}}
					// rowsPerPageOptions={[15, 25]}
					// onPageSizeChange={handleChangeRowsPerPage}
					// pageSize={rowsPerPage}
					/>
				</Box>
			</Box>
		</>
	)
}

export default ReservationHistoryList
